// Import template classes for hydration
import { DefaultTemplate } from "./defaultTemplate";
import { MailRoomFlexibleTemplate } from "./mailRoomFlexibleTemplate";
import { NewlyNotReportingT2MTemplate, NewlyNotReportingAZTemplate, NewlyNotReportingFLTemplate, NewlyNotReportingIDTemplate, NewlyNotReportingNJTemplate, NewlyNotReportingWATemplate, NewlyNotReportingGeneralTemplate, } from "./newlyNotReporting";
import { OhioSercTemplate } from "./ohioSercTemplate";
import { TierIIEmailTemplate } from "./tierIIEmailTemplate";
import { TemplateName, } from "./types";
/**
 * Gets a template instance by name. All templates (including newly-not-reporting)
 * use the same Template interface and TemplateCommunication (tenant, facilities, tierIIReports).
 * For NNR, set facility.newlyNotReportingReason for list templates.
 */
export function getTemplate(templateName) {
    switch (templateName) {
        case TemplateName.TierIIEmailSingle:
        case TemplateName.TierIIEmailBulk:
        case TemplateName.TierIIEmail:
            return new TierIIEmailTemplate().toTemplate();
        case TemplateName.OhioSerc:
            return new OhioSercTemplate().toTemplate();
        case TemplateName.MailRoomFlexible:
            return new MailRoomFlexibleTemplate().toTemplate();
        case TemplateName.NewlyNotReportingGeneral:
            return new NewlyNotReportingGeneralTemplate().toTemplate();
        case TemplateName.NewlyNotReportingT2M:
            return new NewlyNotReportingT2MTemplate().toTemplate();
        case TemplateName.NewlyNotReportingAZ:
            return new NewlyNotReportingAZTemplate().toTemplate();
        case TemplateName.NewlyNotReportingFL:
            return new NewlyNotReportingFLTemplate().toTemplate();
        case TemplateName.NewlyNotReportingID:
            return new NewlyNotReportingIDTemplate().toTemplate();
        case TemplateName.NewlyNotReportingNJ:
            return new NewlyNotReportingNJTemplate().toTemplate();
        case TemplateName.NewlyNotReportingWA:
            return new NewlyNotReportingWATemplate().toTemplate();
        case TemplateName.Default:
        default:
            return new DefaultTemplate().toTemplate();
    }
}
/**
 * Hydrates a template with communication data. Same shape for all templates:
 * tenant (org name), facilities (with optional newlyNotReportingReason for NNR), tierIIReports (reporting year).
 */
export const hydrateTemplate = (templateName, communication) => {
    const template = getTemplate(templateName);
    return {
        subject: template.subject({ communication }),
        text: template.text({ communication }),
        templateId: template.id,
    };
};
//# sourceMappingURL=hydrator.js.map